import { render, staticRenderFns } from "./PrimisBatch.vue?vue&type=template&id=7f75458e"
import script from "./PrimisBatch.vue?vue&type=script&lang=js"
export * from "./PrimisBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports